import { useEffect, useState } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  Typography,
  Box,
  Grid,
  TextField,
  Paper,
  ListItem,
  ListItemText,
  Button,  
  darken,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import FileIcon from "@mui/icons-material/FileUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList } from "react-window";
import { darkenColor } from "../../../../../../../../utils";
import { theme } from "../../../../../../../styles";
import { useEconomicActivityListService } from "../../../../../../../../use-cases/economic-activity-list";
import { useAppSelector } from "../../../../../../../../application/states/hooks";
import { setEditEconomicActivityListNameState } from "../../../../../../../../application/states/economic-activity-list";
import { DialogEconomicActivityListImportFile } from "../../economic-activity-list-dialog";

export const CreateEconomicActivityListForm = () => {
  // Slices
  const user = useAppSelector((state) => state.user);
  const economicActivityList = useAppSelector(
    (state) => state.economicActivityList,
  );
  const openCreateEconomicActivityListForm = useAppSelector(
    (state) => state.economicActivityList.openCreateEconomicActivityListForm,
  );
  const { company } = useAppSelector((state) => state.company);

  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [editingValue, setEditingValue] = useState("");

  // services
  const {
    setCnaeSearchTerm,
    setOpenCreateEconomicActivityListForm,
    setOpenEconomicActivityListImportFile,
    setUpdateCnaeInList,
    setRemoveCnaeFromList,
    setCreateEconomicActivityListName,
    setCreateEconomicActivityListCnae,
    resetCreateEconomicActivityList,
    // setNewCnae,
    // setOldCnae,
    setAddUnitCnae,
    createEconomicActivityList,
  } = useEconomicActivityListService();

  const handleClose = () => {
    resetCreateEconomicActivityList();
    setOpenCreateEconomicActivityListForm(false);
  };

  useEffect(() => {});

  return (
    <>
      <Dialog
        fullScreen
        open={openCreateEconomicActivityListForm}
        keepMounted={false}
        disableEnforceFocus={true}
        disableAutoFocus={true}
        disableRestoreFocus={true}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography
              sx={{ ml: 2, flex: 1 }}
              textTransform="uppercase"
              variant="h6"
              component="div"
            >
              Criar lista de atividades econômicas
            </Typography>
            <Button color="inherit" onClick={handleClose}>
              Fechar
            </Button>
          </Toolbar>
        </AppBar>
        <Box p={3}>
          {/* GRID GERAL*/}

          <Grid container spacing={3}>
            {/* NOME DA LISTA DE CNAES*/}

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nome da lista"
                placeholder="Digite o nome da lista"
                //value={economicActivityList.selectedEconomicActivityList?.name || ""}
                onChange={(e) => {
                  setCreateEconomicActivityListName({
                    name: e.target.value,
                  });
                }}
              />
            </Grid>

            {/* ADCICIONAR CNAE OU IMPORTAR LISTA */}

            <Grid item xs={12}>
              <Paper elevation={3}>
                <Box p={3}>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        textTransform="uppercase"
                        color="primary"
                      >
                        Adicionar CNAE
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Digite o CNAE que deseja adicionar"
                        value={
                          economicActivityList.createEconomicActivityListForm
                            .fields.cnae
                        }
                        onChange={(e) => {
                          setCreateEconomicActivityListCnae({
                            cnae: e.target.value,
                          });
                        }}
                        InputProps={{
                          endAdornment: (
                            <>
                              <Button
                                type="submit"
                                onClick={() => {
                                  setAddUnitCnae({
                                    cnae: economicActivityList
                                      .createEconomicActivityListForm.fields
                                      .cnae,
                                    mode: "create",
                                  });
                                }}
                              >
                                Adicionar
                              </Button>
                            </>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        textTransform="uppercase"
                        align="center"
                        color="primary"
                      >
                        OU
                      </Typography>
                    </Grid>
                    {/* Import de Arquivo */}

                    <Grid item xs={12}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          startIcon={<FileIcon />}
                          variant="contained"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenEconomicActivityListImportFile(true);
                          }}
                          sx={{
                            "&:hover": {
                              backgroundColor: darkenColor(
                                theme.palette.primary.main,
                                10,
                              ),
                            },
                            color:
                              company?.resale === true || company?.resaleId
                                ? theme.palette.primary.contrastText
                                : "#FFF",
                          }}
                        >
                          Importar arquivo
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                </Box>
              </Paper>
            </Grid>

            {/* PESQUISAR CNAE */}
            <Grid item xs={12}>
              <TextField
                label="Pesquisar CNAE"
                placeholder="Digite o CNAE que deseja pesquisar"
                fullWidth
                value={""}
                onChange={(e) => {
                  setCnaeSearchTerm(e.target.value);
                }}
              />
            </Grid>

            {/* DADOS DA LISTA */}
            <Grid item xs={12}>
              <Grid item xs={12}>
                <Typography color="primary" variant="h6">
                  Tamanho:{" "}
                  {economicActivityList.createEconomicActivityListForm.fields.economicActivities
                    ?.filter(
                      (cnae) =>
                        economicActivityList.createEconomicActivityListForm
                          .fields.cnaeSearchTerm === "" ||
                        economicActivityList.createEconomicActivityListForm
                          .fields.cnaeSearchTerm === undefined ||
                        cnae.includes(
                          economicActivityList.createEconomicActivityListForm
                            .fields.cnaeSearchTerm,
                        ),
                    )
                    .length.toLocaleString("pt-BR") || 0}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                height={
                  (economicActivityList.createEconomicActivityListForm.fields
                    .economicActivities?.length ?? 0) <= 3
                    ? 175
                    : 250
                }
                maxHeight={400}
              >
                <AutoSizer>
                  {(data: any) => (
                    <FixedSizeList
                      height={
                        (economicActivityList.createEconomicActivityListForm
                          .fields.economicActivities?.length ?? 0) <= 3
                          ? 175
                          : 250
                      }
                      style={{
                        maxHeight: 400,
                      }}
                      width={data.width}
                      itemSize={60}
                      itemCount={
                        economicActivityList.createEconomicActivityListForm.fields.economicActivities?.filter(
                          (cnae) => {
                            if (
                              economicActivityList
                                .createEconomicActivityListForm.fields
                                .cnaeSearchTerm === "" ||
                              economicActivityList
                                .createEconomicActivityListForm.fields
                                .cnaeSearchTerm === undefined ||
                              cnae.includes(
                                economicActivityList
                                  .createEconomicActivityListForm.fields
                                  .cnaeSearchTerm,
                              )
                            ) {
                              return true;
                            } else {
                              return false;
                            }
                          },
                        ).length ?? 0
                      }
                      overscanCount={15}
                    >
                      {({ index, style }) => {
                        const item =
                          economicActivityList.createEconomicActivityListForm.fields.economicActivities?.filter(
                            (cnae) => {
                              if (
                                economicActivityList
                                  .createEconomicActivityListForm.fields
                                  .cnaeSearchTerm === "" ||
                                economicActivityList
                                  .createEconomicActivityListForm.fields
                                  .cnaeSearchTerm === undefined ||
                                cnae.includes(
                                  economicActivityList
                                    .createEconomicActivityListForm.fields
                                    .cnaeSearchTerm,
                                )
                              ) {
                                return true;
                              } else {
                                return false;
                              }
                            },
                          )[index];

                        const isEditing = editingIndex === index;

                        return (
                          <ListItem
                            style={style}
                            secondaryAction={
                              <>
                                {!isEditing ? (
                                  // Modo visualização - botões Editar e Excluir
                                  <>
                                    <Button
                                      style={{
                                        marginRight: "10px",
                                      }}
                                      startIcon={<EditIcon />}
                                      onClick={() => {
                                        setEditingIndex(index);
                                        setEditingValue(item ?? "");
                                      }}
                                    >
                                      Editar
                                    </Button>
                                    <Button
                                      onClick={() => {
                                        // Implementar função de excluir
                                        setRemoveCnaeFromList({
                                          value: item ?? "",
                                          index: index,
                                          mode: "create",
                                        });
                                      }}
                                      startIcon={<DeleteIcon />}
                                    >
                                      Excluir
                                    </Button>
                                  </>
                                ) : (
                                  // Modo edição - botões Confirmar e Cancelar
                                  <>
                                    <Button
                                      sx={{
                                        marginRight: "10px",
                                        "&:hover": {
                                          color:
                                            company?.resale === true ||
                                            company?.resaleId ? theme.palette.primary.contrastText
                                              : theme.palette.primary
                                                    .contrastText,
                                          backgroundColor:
                                            company?.resale === true ||
                                            company?.resaleId
                                              ? darken(theme.palette.primary.main, 0.2)                                                
                                              : darken(theme.palette.primary.main, 0.2),
                                          cursor: "default",
                                        },
                                      }}
                                      variant="contained"
                                      color="primary"
                                      size="small"
                                      onClick={() => {
                                        // Implementar função de confirmar edição
                                        setUpdateCnaeInList({
                                          oldValue: item ?? "",
                                          newValue: editingValue,
                                          index: index,
                                          mode: "create",
                                        });
                                        setEditingIndex(null);
                                        setEditingValue("");
                                      }}
                                    >
                                      Confirmar
                                    </Button>
                                    <Button
                                      variant="outlined"
                                      color="error"
                                      size="small"
                                      startIcon={
                                        <span style={{ fontSize: "20px" }}>
                                          ✕
                                        </span>
                                      }
                                      onClick={() => {
                                        setEditingIndex(null);
                                        setEditingValue("");
                                      }}
                                    >
                                      Cancelar
                                    </Button>
                                  </>
                                )}
                              </>
                            }
                          >
                            {!isEditing ? (
                              // Modo visualização - texto simples
                              <ListItemText primary={item} />
                            ) : (
                              // Modo edição - TextField sem bordas
                              <TextField
                                fullWidth
                                variant="standard"
                                value={editingValue}
                                onChange={(e) =>
                                  setEditingValue(e.target.value)
                                }
                                InputProps={{
                                  disableUnderline: true,
                                  style: {
                                    fontSize: "1rem",
                                    padding: "8px 0",
                                  },
                                }}
                                autoFocus
                                onKeyPress={(e) => {
                                  if (e.key === "Enter") {
                                    // Confirmar com Enter
                                    // updateCnaeInList({
                                    //   oldValue: item,
                                    //   newValue: editingValue,
                                    //   index: index
                                    // });
                                    setEditingIndex(null);
                                    setEditingValue("");
                                  }
                                }}
                              />
                            )}
                          </ListItem>
                        );
                      }}
                    </FixedSizeList>
                  )}
                </AutoSizer>
              </Grid>
            </Grid>

            {/* BOTÃO SALVAR ALTERAÇÕES */}

            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                sx={{
                  "&:hover": {
                    backgroundColor: darkenColor(
                      theme.palette.primary.main,
                      10,
                    ),
                  },
                }}
                onClick={() => {
                  createEconomicActivityList({
                    userId: user.id,
                    name: economicActivityList.createEconomicActivityListForm
                      .fields.name,
                    economicActivityList:
                      economicActivityList.createEconomicActivityListForm.fields
                        .economicActivities,
                  });
                }}
              >
                Criar Lista
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Dialog>

      <DialogEconomicActivityListImportFile />
    </>
  );
};
